export const getAgentFilterValue = (userdata) => {
    const { isDiamondAirUser, isHubDropUser } = userdata;

    let agent = 'ALL';

    if (isDiamondAirUser && !isHubDropUser) {
        agent = 'DiamondAirBookings';
    } else if (isHubDropUser && !isDiamondAirUser) {
        agent = 'HubDropBookings';
    }

    return agent;
};

export const getAgentDropDownValues = (userdata) => {
    const { isDiamondAirUser, isHubDropUser } = userdata;

    let menu_items = [
        {
            name: 'All Bookings',
            value: 'ALL',
        },
        {
            name: 'Diamond Air Only',
            value: 'DiamondAirBookings',
        },
        {
            name: 'Hub Drop Only',
            value: 'HubDropBookings',
        },
    ];

    if (isDiamondAirUser && !isHubDropUser) {
        menu_items = [
            // {
            //     name: 'Diamond Air Only',
            //     value: 'DiamondAirBookings',
            // },
        ];
    } else if (isHubDropUser && !isDiamondAirUser) {
        menu_items = [
            // {
            //     name: 'Hub Drop Only',
            //     value: 'HubDropBookings',
            // },
        ];
    }

    return menu_items;
};

export const getStatus = (status: number | string) => {
    switch (status) {
        case 'ScheduledNotStarted':
            return 'ScheduledNotStarted';

        case 'ScheduledTimeslotStarted':
            return 'ScheduledTimeslotStarted';

        case 'InProgress':
            return 'InProgress';

        case 'Completed':
            return 'complete';

        case 'IssueOrWarning':
            return 'IssueOrWarning';

        case 'ImmediateActionRequired':
            return 'ImmediateActionRequired';

        case 'Cancelled':
            return 'cancelled';

        default:
            return 'pending';
    }
};
